import axios from "axios";
import {
  Autocomplete,
  Button,
  Checkbox,
  FloppyDiskIcon,
  Pane,
  Text,
  TextInputField,
} from "evergreen-ui";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { FaGears } from "react-icons/fa6";

function CheckVutMaster() {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Basic " + localStorage.getItem("token"),
  };
  const [DataVutMaster, setDataVutMaster] = useState([]);
  const fetchLEvelMaster = async () => {
    try {
      axios
        .post(
          "https://mua.kpru.ac.th/FrontEnd_Admission/admission/plan/",
          { level: "5" },
          { headers: headers }
        )
        .then((res) => {
          console.log(res.data, "1111");
          const loopdata = res.data;
          setDataVutMaster(loopdata);
          setGPA(localStorage.getItem("vga"));
          if (localStorage.getItem("plan") !== "") {
            const index = loopdata.findIndex(
              (item) => item.value === localStorage.getItem("plan")
            );
            setGrade(localStorage.getItem("plan"));
            setSelectedItem(index);
            console.log(index);
          } else {
          }
        });
    } catch (error) {}
  };
  const fetVut = async () => {
    try {
      const fetch = await axios.get(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showcheckvut",
        { headers }
      );
      const dataVut = fetch.data.data.data;
      const data = fetch.data.data.data[0];
      console.log(dataVut);
      if (dataVut.length !== 0) {
        if (data.LEVEL_EDU_ID >= 5) {
          localStorage.setItem("level", data.LEVEL_EDU_ID);
          localStorage.setItem("plan", data.PLAN_ID);
          localStorage.setItem("vga", data.LEVEL_MEMBER_VGA);
        } else {
          localStorage.setItem("level", "5");
          localStorage.setItem("plan", "");
          localStorage.setItem("vga", "");
        }
        // console.log(dataVut, "dfVut");
        setChkFetch(true);
      }
    } catch (error) {}
  };
  const [Grade, setGrade] = useState("");
  const [GPA, setGPA] = useState("");
  const [VutKru, setVutKru] = useState("");
  const [ChkFetch, setChkFetch] = useState(false);
  useEffect(() => {
    // let headerss = {
    //   "Content-Type": "application/json",
    //   "Authorization": "Base eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3MDE0MTczODgsImV4cCI6MTcwMTYzMzM4OCwidXNlcmlkIjoiMTYyOTkwMDUzMTY2NiJ9.BlJB2YxLt6N4Q-3CadkBDvWv04V3nEqvRjmPrF_bi6Q",
    //   "content-type": "multipart/form-data",
    // };
    // axios.get("https://git.kpru.ac.th/apiwithdraw/Subject/SubjectPerson3",{headers:headerss}).then((res) => {
    //   console.log(res.data);
    // });
    fetVut();
    fetchLEvelMaster();
  }, []);
  useEffect(() => {}, [ChkFetch]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [Kru, setKru] = useState(null);
  return (
    <>
      <Pane className="container p-2">
        <Pane
          className="bg-white p-2 px-3 d-flex flex-wrap"
          borderRadius={8}
          boxShadow="0px 0px 10px #00000030"
        >
          <div
            className="col-12 pb-3"
            style={{ fontSize: "22px", fontWeight: "500" }}
          >
            วุฒิการศึกษา
          </div>
          <div className="col-12 pb-1" style={{ fontSize: "16px" }}>
            -- ระดับปริญญาตรี  &nbsp;{" "}
            <Text className="text-danger">* หากไม่พบข้อมูล โทร. 055-706547</Text>
          </div>
          <div className="col-md-8">
            <Autocomplete
              items={DataVutMaster}
              selectedItem={DataVutMaster[selectedItem]}
              itemToString={(item) => (item ? item.label : "")}
              // defaultHighlightedIndex={DataVutMaster[5]}
              onChange={(changedItem) => {
                localStorage.setItem("level", "5");
                localStorage.setItem("plan", changedItem.value);
                setGrade(changedItem.value);
              }}
            >
              {({
                key,
                getInputProps,
                getToggleButtonProps,
                getRef,
                inputValue,
                openMenu,
                toggleMenu,
              }) => (
                <Pane
                  width="100%"
                  ref={getRef}
                  display="flex "
                  alignItems="center"
                  gap={10}
                >
                  <TextInputField
                    width="100%"
                    key={key}
                    placeholder="เลือกวุฒิการศึกษา"
                    value={inputValue}
                    onFocus={openMenu}
                    {...getInputProps()}
                    label="เลือกสาขา"
                    name="major"
                  />
                  <Button
                    iconBefore={<FaGears />}
                    appearance="primary"
                    onClick={toggleMenu}
                    {...getToggleButtonProps()}
                  >
                    เปิดตัวเลือก
                  </Button>
                </Pane>
              )}
            </Autocomplete>
          </div>
          <div className="col-md-4">
            <TextInputField
              label="ผลการเรียน"
              value={GPA}
              name="gpa"
              onChange={(e) => {
                localStorage.setItem("vga", e.target.value);
                setGPA(e.target.value);
              }}
              maxLength={4}
            />
          </div>
          <div className="col-8">
            <Checkbox
              checked={Kru === true}
              onChange={() => {
                setKru(true);
                setVutKru("have");
              }}
              label="มีใบประกาศนียบัตรบัณฑิต (วิชาชีพครู)"
            />
            <Checkbox
              checked={Kru === false}
              onChange={() => {
                setKru(false);
                setVutKru("not");
              }}
              label="ไม่มีใบประกาศนียบัตรบัณฑิต (วิชาชีพครู)"
            />
          </div>
          <div className="col-12 d-flex flex-row justify-content-end">
            <Button
              iconBefore={<FloppyDiskIcon />}
              appearance="primary"
              intent="success"
              disabled={
                GPA === "" || Grade === "" || Kru === null ? true : false
              }
              onClick={() => {
                localStorage.setItem("vga2", "");
                localStorage.setItem("plan2", "");
                localStorage.setItem("level2", "");
                if (VutKru === "have") {
                  localStorage.setItem("vga3", "0.00");
                  localStorage.setItem("plan3", "579");
                  localStorage.setItem("level3", "13");
                } else {
                  localStorage.setItem("vga3", "");
                  localStorage.setItem("plan3", "");
                  localStorage.setItem("level3", "");
                }
                window.location.pathname = "admission/Formregister-master";
              }}
            >
              บันทึก
            </Button>
          </div>
        </Pane>
      </Pane>
    </>
  );
}

export default CheckVutMaster;
